import { render, staticRenderFns } from "./AddRoadTaxModal.vue?vue&type=template&id=5cfca53c&"
import script from "./AddRoadTaxModal.vue?vue&type=script&lang=js&"
export * from "./AddRoadTaxModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports